import { ProfessionalView } from '@elio/emanager-front/professional/offer/model';
import { createAction, props } from '@ngrx/store';

const upsertProfessionalSuccess = createAction(
  '[Professional Form Store] Upsert professional SUCCESS',
  props<{ professionalView: ProfessionalView }>()
);

export const ProfessionalFormActions = {
  upsertProfessionalSuccess,
};
